import React, { ReactNode } from 'react';
import clsx from 'clsx';
import { ReactComponent as IconEmail } from 'images/email.svg';
import styles from './Input.module.scss';
import { useTranslation } from 'react-i18next';

type InputComponentProps = {
  className?: string,
  onChange?: (e: React.FormEvent<HTMLInputElement>) => void,
  onChangeValue?: (v: string) => void,
  onClick?: (e?: React.FormEvent<HTMLDivElement>) => void,
  value?: string,
  disabled?: boolean,
  type?: Exclude<string, 'textarea'>,
  placeholder?: string,
  icon?: ReactNode,
  suffix?: ReactNode,
  error?: boolean,
  errorMessage?: string,
  onFocus?: () => void,
  onBlur?: () => void,
  maxLength?: number | undefined,
  wide?: boolean,
  white?: boolean,
  gray?: boolean,
  searchLeft?: boolean,
  inputRef?: any,
  style?: React.CSSProperties
}

function Input({
  className = '',
  onClick = () => { },
  onChange,
  onChangeValue,
  value = '',
  disabled = false,
  type = 'text',
  placeholder = '',
  icon = null,
  suffix = null,
  error = false,
  errorMessage = '',
  maxLength,
  wide = true,
  white = false,
  gray = false,
  searchLeft = false,
  onBlur,
  onFocus,
  inputRef,
  style,
  ...restInputProps
}: InputComponentProps) {
  const {t} = useTranslation() as any
  let prefixIcon: ReactNode = null
  if (icon !== null && icon !== undefined) {
    // If icon is explicitly provided (including for date type), use it
    prefixIcon = icon
  } else if (type === 'email' && icon !== null) {
    prefixIcon = (<IconEmail />)
  }

  return (
    <>
      <div
        className={clsx(
          styles.container,
          className,
          disabled && styles.containerDisabled,
          (value === '') && styles.containerEmpty,
          wide && styles.containerWide,
          white && styles.containerWhite,
          error && styles.error,
          gray && styles.containerGray,
        )}
        onClick={onClick}
        style={style}
      >
        { // @ts-ignore
          prefixIcon ? (<div className={clsx(styles.prefix, gray && styles.prefixGray, searchLeft && styles.prefixSearchLeft)}>{prefixIcon}</div>) : null
        }
        <input
          ref={inputRef}
          value={value}
          onChange={onChange || ((e) => (onChangeValue && onChangeValue(e?.target?.value)))}
          className={clsx(
            styles.input,
            white && styles.inputWhite,
            gray && styles.inputGray,
          )}
          disabled={disabled}
          type={type}
          placeholder={t(placeholder)}
          maxLength={maxLength}
          onFocus={onFocus}
          onBlur={onBlur}
          {...restInputProps}
        />
        {suffix}
      </div>
      {(error && errorMessage) && (
        <div className={styles.errorMessage}>{t(errorMessage)}</div>
      )}
    </>
  )
}

export default Input
